import React from "react";
import SignInSingUpForm from "../components/SignInSingUpForm";

function SignIn() {
    return (
        <>
            <SignInSingUpForm type="signin" />
        </>
    );
}

export default SignIn;
